/**
 * The only new arithmetic this feature adds. Liquid resolves the increment
 * (snippets/sales-increment.liquid, FR-001b/c, FR-003) and hands it to
 * JavaScript as data — this function never re-resolves from metafields, it
 * only rounds a typed quantity. See
 * specs/008-quantity-increments/contracts/theme-resolution.md.
 *
 * @param {number} q - what the customer typed
 * @param {number} k - resolved increment (0 or 1 both mean unrestricted)
 * @param {number|null} ceiling - stock cap, or null when stock isn't enforced
 * @returns {number} the quantity to use
 */
function roundUpToIncrement(q, k, ceiling) {
  if (k <= 1) return q;
  if (q === 0) return 0;

  let result = q % k === 0 ? q : Math.ceil(q / k) * k;

  if (ceiling !== null && ceiling !== undefined && result > ceiling) {
    result = Math.floor(ceiling / k) * k;
  }

  return result;
}

window.roundUpToIncrement = roundUpToIncrement;
